import { Store, Module, ActionContext } from 'vuex';
import ListModule from '../list-module';
import ListState from '../list-state';
import Product from '@/store/entities/baseInfo/Product';
import Ajax from '@/lib/ajaxBaseInfo';
import PageResult from '@/store/entities/page-result';
import Util from '@/lib/util';
import ProductCategory from '@/store/entities/baseInfo/ProductCategory';

interface ProductState extends ListState<Product> {
    editProduct: Product;
    adList: Array<Product>;
    newestList: Array<Product>;
    similarList: Array<Product>;
    searchedByImageList: Array<Product>;
    product: Product;
    productCategory: ProductCategory;
    productionCount: number;
    keywords: Array<string>;
}

class ProductModule extends ListModule<ProductState, any, Product> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Product>(),
        adList: new Array<Product>(),
        newestList: new Array<Product>(),
        similarList: new Array<Product>(),
        searchedByImageList: new Array<Product>(),
        loading: false,
        editProduct: new Product(),
        product: new Product(),
        productCategory: new ProductCategory(),
        productionCount: 0,
        keywords: new Array<string>()
    }
    actions = {
        async getList(context: ActionContext<ProductState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/Product/GetList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Product>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getRecommendationKeywordsList(context: ActionContext<ProductState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/Product/getRecommendationKeywordsList', {
                params: {
                    takeCount: 8
                }
            });
            context.state.loading = false;
            context.state.keywords = reponse.data.result;
        },
        async getAdList(context: ActionContext<ProductState, any>) {
            context.state.loading = true;
            let reponse = await Ajax.get('/Product/GetAdList');
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Product>;
            context.state.totalCount = page.totalCount;
            context.state.adList = page.items;
        },
        async getNewestList(context: ActionContext<ProductState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/Product/GetNewestList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Product>;
            context.state.totalCount = page.totalCount;
            context.state.newestList = page.items;
        },
        async getAllByVendor(context: ActionContext<ProductState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/Product/GetAllByVendor', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Product>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getListByVendor(context: ActionContext<ProductState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/Product/getListByVendor', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Product>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getSimilarList(context: ActionContext<ProductState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/Product/GetSimilarList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Product>;
            context.state.totalCount = page.totalCount;
            context.state.similarList = page.items;
        },
        async create(context: ActionContext<ProductState, any>, payload: any) {
            await Ajax.post('/Product/Create', payload.data);
        },
        async update(context: ActionContext<ProductState, any>, payload: any) {
            await Ajax.put('/Product/Update', payload.data);
        },
        async delete(context: ActionContext<ProductState, any>, payload: any) {
            await Ajax.delete('/Product/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<ProductState, any>, payload: any) {
            let reponse = await Ajax.get('/Product/Get?Id=' + payload.data.id);
            context.state.editProduct = reponse.data.result as Product; // set value for editing.
            return reponse.data.result as Product;
        },
        async getTotalCountByVendor(context: ActionContext<ProductState, any>, payload: any) {
            let reponse = await Ajax.get('/Product/getTotalCountByVendor?vendorNo=' + payload.data);
            context.state.productionCount = reponse.data.result;
            return reponse.data.result;
        },
        async getByNo(context: ActionContext<ProductState, any>, payload: any) {
            let reponse = await Ajax.get('/Product/GetByNo?no=' + payload.data);
            let product = reponse.data.result as Product;
            product.creationTime = Util.formatDate(new Date(product.creationTime), 'yyyy.MM.dd');
            context.state.product = product; // set value for editing.
            context.state.productCategory = Util.getCategory(product.productCategoryNo);
            return context.state;
        },
        // Used in HTML editors which need to upload image function
        async uploadImage(context: ActionContext<ProductState, any>, payload: any) {
            let reponse = await Ajax.post('/api/uploadImage?usage=BaseInfoProduct', payload.data, { headers: { 'Content-Type': 'multipart/form-data' } });
            var result = reponse.data.result.location;
            return result;
        },
        async searchByImage(context: ActionContext<ProductState, any>, payload: any) {
            let reponse = await Ajax.post('/Product/SearchByImage', payload.data, { headers: { 'Content-Type': 'multipart/form-data' } });
            var result = reponse.data.result.location;
            return result;
        },
        async getSearchedImageData(context: ActionContext<ProductState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/Product/GetSearchedImageData', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Product>;
            context.state.totalCount = page.totalCount;
            context.state.searchedByImageList = page.items;
        }
    };
    mutations = {
        setCurrentPage(state: ProductState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ProductState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const productModule = new ProductModule();
export default productModule;